import './SamFundDataFundPage.scss';

// Async boundary required by Module Federation.
//
// All access to shared modules (React, ReactDOM — provided via the federation
// loadShare runtime) must happen AFTER the federation runtime has finished
// initializing. With static top-level imports here, WebKit/iOS evaluates this
// entry module before the federation init top-level await has settled, so the
// shared React binding is still in its temporal dead zone → "Cannot access 'X'
// before initialization", and the microfrontend never mounts (blank on iOS,
// works on Chrome which happens to order evaluation differently).
//
// A dynamic import() defers the real work into a separate module and waits for
// its entire graph — including the federation init top-level await — to settle
// first. This is the canonical Module Federation host bootstrap pattern.
//
// The resilience layer (error boundary, retry, logging) lives inside ./mount,
// so if the mount chunk itself fails to load there is nothing there to catch
// it. Log locally and to the backend client log (Kibana, gated server-side by
// EnableClientLogging) so this failure isn't silent. The logger is imported
// dynamically so it (and axios) only loads on this rare error path, keeping the
// bootstrap entry minimal.
import('./mount').catch((error) => {
  console.error('[FundData MFE] Failed to load mount chunk', error);
  void import('../../utils/logger')
    .then(({ logger }) => {
      logger.error(
        `[FundData MFE] FundSheet mount chunk failed to load: ${error?.message ?? error}`,
      );
    })
    .catch(() => {
      /* logging is best-effort */
    });
});
